module.exports = __webpack_public_path__ + "static/media/1.61bf720b.jpg";